import topic from '../topic'
export const ppotAPI = {
    getPpots: topic.ppotTopic + '/get_ppots',
    // getPpotById: topic.ppotTopic + '/get_ppot_by_id',
    addPpotPndPpin: topic.ppotTopic + '/add_ppot_and_ppin',
    // editPpot: topic.ppotTopic + '/edit_ppot',
    destroyPpotByIds: topic.ppotTopic + '/destroy_ppot_by_ids'
}